import { ReactNode } from 'react';
const GeneralContainerView = ({ children }: { children: ReactNode }) => {
  return <div id="generalContainerView">{children}</div>;
};
export default GeneralContainerView;
